module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/administracao/usuarios/novo"
    }
  }, [_vm._v("Novo")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.filtro),
      expression: "dados.filtro"
    }],
    ref: "filtro_pesquisa",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Busca: Entre com o nome do usuário",
      "name": "filtro_pesquisa",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.filtro)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataTable($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "filtro", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.apiData.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.login))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("nivel")(item.nivel)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.empresa.fantasia))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "tag": "button",
        "to": '/administracao/usuarios/atualizacao/' + item.id,
        "title": "Atualizar"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit"
    })]), _vm._v(" "), _vm._m(2, true)], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tMostrando " + _vm._s(this.apiData.from) + " até " + _vm._s(this.apiData.to) + " de " + _vm._s(this.apiData.total) + " registros encontrados.\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.apiData
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Usuários do Sistema")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("Nível")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("Ação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger btn-sm",
    attrs: {
      "title": "Bloquear"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-882205e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/usuarios/index.vue
// module id = 409
// module chunks = 1